module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921044149_T.e0e13c5c.jpg";